import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import bg from '../../images/pricing.webp'
import { useMediaQuery } from 'react-responsive';
import { setToggleTrue } from '../../redux/slice/changeState'
import { useDispatch } from 'react-redux';

const Pricing = () => {
  const dispatch = useDispatch()
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <div className='pricing-section section-padding' id='pricing-section' style={{ backgroundImage: `url(${bg})` }}>
      <Container>
        <div className={`heading-div ${isMobile ? 'text-start' : 'text-center'}`}>
          <h1 className='primary-color'>IRA Aspiration:</h1>
          {!isMobile?<h1 className='primary-color'>Competitive Pricing, Ready to Move In</h1>:<h1 className='primary-color'>Competitive Pricing, <br/>Ready to Move In</h1>}

        </div>
        <h6 className={`mb-3 mt-1 text-capitalize ${isMobile ? 'text-start' : 'text-center'}`}>2&3 BHK apartments in Kollur</h6>
        <Row>
          <Col lg={6} md={6} xs={12} style={{ paddingRight: isMobile ? '' : '5%', marginBottom: isMobile ? '10%' : '' }}>
            <div className='pricing-detail'>
              <p>2 BHK</p>
              <p className='fw-light'>Starting from</p>
              <h1 className={`${isMobile ? 'mb-3' : 'mb-4'}`}>₹97 Lakhs*</h1>
              <button className='limited-btn'>Limited Units Available</button>
              <hr />
              <button className='avial-btn avail1' onClick={() => dispatch(setToggleTrue())}>Contact Us for Availability</button>
            </div>
          </Col>
          <Col lg={6} md={6} xs={12} style={{ paddingLeft: isMobile ? '' : '5%' }}>
            <div className='pricing-detail'>
              <p>3 BHK</p>
              <p className='fw-light'>Starting From </p>
              <h1 className={`${isMobile ? 'mb-3' : 'mb-4'}`}>₹1.2 Cr*</h1>
              <button className='limited-btn'>Immediate Handover</button>
              <hr />
              <button className='avial-btn avail2' onClick={() => dispatch(setToggleTrue())}>Contact Us for Availability</button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Pricing
